import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import(/* webpackChunkName: "Download" */ '../views/NewDownload.vue')
  },
  {
    path: '/features',
    name: 'Features',
    component: () => import(/* webpackChunkName: "Features" */ '../views/Features.vue')
  },
  {
    path: '/user_proto',
    name: 'agree',
    component: () => import(/* webpackChunkName: "Agree" */ '../views/Agree.vue')
  },
  {
    path: '/proto',
    name: 'agree2',
    component: () => import(/* webpackChunkName: "Agree2" */ '../views/Agree2.vue')
  },
  {
    path: '/proto2',
    name: 'proto2',
    component: () => import(/* webpackChunkName: "Agree2" */ '../views/proto_huawei.vue')
  },
  {
    path: '/sy-service',
    name: 'SYService',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/SYService.vue')
  },
  {
    path: '/sy-secret',
    name: 'SYSecret',
    component: () => import(/* webpackChunkName: "SYSecret" */ '../views/SYSecret.vue')
  },
  {
    path: '/:lan/invite/friends',
    name: 'InviteFriends',
    meta: { title: '邀请好友' },
    component: () => import(/* webpackChunkName: "InviteFriends" */ '../views/InviteFriends.vue')
  },
  {
    path: '/advert/index',
    name: 'Frees',
    meta: { title: 'FREES 高端私密社交' },
    component: () => import(/* webpackChunkName: "Frees" */ '../views/advert/index.vue')
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/knowledge.vue')
  },
  {
    path: '/paymentagreement',
    name: 'paymentagreement',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/paymentagreement')
  },
  {
    path: '/apply/index',
    name: '默往专业版开放申请',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/apply/index')
  },
  {
    path: '/major',
    name: 'major',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/major')
  },
  {
    path: '/activity/index',
    name: '默往会员优惠大放送',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/activity/index')
  },
  {
    path: '/lingkong-ai',
    name: 'LingkongAi',
    meta: {
      title: '灵空AI'
    },
    component: () => import(/* webpackChunkName: "LingkongAi" */ '../views/lingkong-ai/index.vue')
  },
  {
    path: '/notice/index',
    name: '默往网页版正式上线',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/notice/index')
  },
  {
    path: '/mwrecharge',
    name: '默往币充值协议',
    component: () => import(/* webpackChunkName: "SYService" */ '../views/mwrecharge')
  },
  {
    path: '/invite',
    name: 'NewInvite',
    component: () => import(/* webpackChunkName: "NewInvite" */ '../views/invite/index.vue')
  },
  {
    path: '/coin/recharge',
    name: 'CoinRecharge',
    meta: {
      title: '充值默往币'
    },
    component: () => import(/* webpackChunkName: "CoinRecharge" */ '../views/recharge/index.vue')
  },
  {
    path: '/coin/recharge/agreement',
    name: 'CoinRechargeAgreement',
    meta: {
      title: '默往币充值协议'
    },
    component: () => import(/* webpackChunkName: "CoinRechargeAgreement" */ '../views/recharge/Agreement.vue')
  },
  {
    path: '/worldcup2026',
    name: 'WorldCup2026',
    meta: {
      title: '2026世界杯'
    },
    component: () => import(/* webpackChunkName: "WorldCup2026" */ '../views/worldcup2026/index.vue'),
    redirect: '/worldcup2026/schedule',
    children: [
      {
        path: 'schedule',
        name: 'WorldCup2026Schedule',
        component: () => import(/* webpackChunkName: "WorldCup2026" */ '../views/worldcup2026/tabs/ScheduleTab.vue')
      },
      {
        path: 'rank',
        name: 'WorldCup2026Rank',
        component: () => import(/* webpackChunkName: "WorldCup2026" */ '../views/worldcup2026/tabs/RankTab.vue')
      },
      {
        path: 'team',
        name: 'WorldCup2026Team',
        component: () => import(/* webpackChunkName: "WorldCup2026" */ '../views/worldcup2026/tabs/TeamTab.vue')
      },
      {
        path: 'news',
        name: 'WorldCup2026News',
        component: () => import(/* webpackChunkName: "WorldCup2026" */ '../views/worldcup2026/tabs/NewsTab.vue')
      },
      {
        path: 'team/:teamId',
        name: 'WorldCup2026TeamDetail',
        component: () => import(/* webpackChunkName: "WorldCup2026" */ '../views/worldcup2026/detail/TeamDetail.vue')
      },
      {
        path: 'news/:newsId',
        name: 'WorldCup2026NewsDetail',
        component: () => import(/* webpackChunkName: "WorldCup2026" */ '../views/worldcup2026/detail/NewsDetail.vue')
      }
    ]
  },
  {
    path: '/worldcup-quiz',
    name: 'WorldCupQuiz',
    meta: {
      title: '世界杯竞猜'
    },
    component: () => import(/* webpackChunkName: "WorldCupQuiz" */ '../views/worldcupQuiz/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

export default router
